import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../../auth/useAuthContext";
import LoadingPage from "./LoadingPage";

function ProtectedRoute({ children, allowedRoles = [] }) {
    const location = useLocation();
    const { user, isAuthenticated, isInitialized, hasRole } = useAuthContext();

    if (!isInitialized) {
        return <LoadingPage />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // ✅ استخدام hasRole بدلاً من التحقق اليدوي
    if (!hasRole(allowedRoles)) {
        if (user?.role === "business" || user?.role === "mall") {
            return <Navigate to="/vendor" replace />;
        } else if (user.role === "sub_business") {
            return <Navigate to="/shop" replace />;
        } else if (user.role === "marketer") {
            return <Navigate to="/marketer" replace />;
        } else {
            return <Navigate to="/login" replace />;
        }
    }

    return children;
}

export default ProtectedRoute;
